// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"2bc6e797","453":"a45c53dc"}[chunkId] + ".chunk.js";
};